import { useRemoteConfig } from 'context/RemoteConfigContextProvider';
import { useEffect, useMemo, useState } from 'react';
import { getPremiumPuzzlePricesById } from 'services/api/premiumPuzzlePricesApi';
import { PremiumPuzzlePrice } from 'types/components/PremiumPuzzlePrice';

import { getDropdownPuzzlePremiumOptions } from '../utilities';

const usePremiumPuzzlePrices = () => {
  const [isLoadingPremiumPuzzlePrices, setIsLoadingPremiumPuzzlePrices] = useState<boolean>(false);
  const [premiumPuzzlePricesDocId, setPremiumPuzzlePricesDocId] = useState<string | null>(null);
  const [premiumPuzzlePrices, setPremiumPuzzlePrices] = useState<PremiumPuzzlePrice | null>();
  const remoteConfig = useRemoteConfig();

  useEffect(() => {
    const id = remoteConfig?.economy_jpu_premium_puzzle_prices;
    setPremiumPuzzlePricesDocId(id && id !== '' ? id : null);
  }, [remoteConfig]);

  useEffect(() => {
    (async () => {
      if (premiumPuzzlePricesDocId) {
        setIsLoadingPremiumPuzzlePrices(true);
        const data = await getPremiumPuzzlePricesById(premiumPuzzlePricesDocId);
        if (data) setPremiumPuzzlePrices(data);
        setIsLoadingPremiumPuzzlePrices(false);
      }
    })();
  }, [premiumPuzzlePricesDocId]);

  const premiumPuzzlePricesDropdownList: any = useMemo(
    () => getDropdownPuzzlePremiumOptions(premiumPuzzlePrices as PremiumPuzzlePrice),
    [premiumPuzzlePrices],
  );

  return {
    premiumPuzzlePricesDocId,
    premiumPuzzlePrices,
    premiumPuzzlePricesDropdownList,
    isLoadingPremiumPuzzlePrices,
  };
};

export default usePremiumPuzzlePrices;
